import Box from "@mui/material/Box";
import React, { FC, memo } from "react";

type ResizerProps = {
  handleMouseDown: React.MouseEventHandler<HTMLDivElement>;
};

const ResizerComponent: FC<ResizerProps> = ({ handleMouseDown }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: -5,
        width: "10px",
        minWidth: "10px",
        height: "100%",
        cursor: "col-resize",
        borderRadius: "5px",
        zIndex: 2,
        "&:hover": {
          backgroundColor: (theme) => theme.palette.primary.main,
        },
      }}
      onMouseDown={handleMouseDown}
    />
  );
};

export const Resizer = memo(ResizerComponent);
